'use strict'

angular.module('rmEPG')
    .controller('BroadcastScheduleCtrl', require('./broadcast_schedule_ctrl'))
    .controller('EpgBroadcastFormCtrl', require('./epg_broadcast_form_ctrl').default)
